
// @ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator'
import SellerHeader from '@/components/Seller/SellerHeader.vue'
import { createRecepcionist } from '@/services/seller.service'
import { ErrorMessages } from '@/helpers/constants'
import { UserInterface } from '@/interfaces/user.interface'
import { Validate } from 'vuelidate-property-decorators'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'

@Component({
  components: {
    SellerHeader,
  },
})
export default class EditRecepcionist extends Vue {
  recepcionist: UserInterface = {}

  @Validate({ minLength: minLength(8) }) password = ''
  @Validate({ sameAsPassword: sameAs('password') }) passwordRepeat = ''

  passwordRepeat = ''

  async submitCreate() {
    try {

      const body = {
        fullname: this.recepcionist.fullname,
        email: this.recepcionist.email,
        password: this.passwordRepeat,
        active: this.recepcionist.active || false
      };

      const response: any = await createRecepcionist(body)

      if (response.status == 200) {
        Vue.$toast.success(`Recepcionista creado correctamente`)

        setTimeout(() => {
          this.$router.push({
            name: 'Compartir usuario',
            params: {
              fullname: this.recepcionist.fullname,
              username: this.recepcionist.email,
              email: this.recepcionist.email,
              password: this.passwordRepeat,
              title: 'Compartir Recepcionista',
              to: '/seller/administration/recepcionist-list'
            },
          })
        }, 500)
      } else {
        Vue.$toast.error('Ha ocurrido un error actualizando el recepcionista')
      }
    } catch (e) {
      console.error(e)
      Vue.$toast.error(ErrorMessages.COMMON)
    }
  }

  mounted() {
  }


  /* INPUT VALIDATIONS */
  get passwordRepeatErrors(): Array<string> {
    const errors: Array<string> = []
    if (!this.$v.passwordRepeat.$dirty) return errors
    !this.$v.passwordRepeat.sameAsPassword &&
      errors.push('Las contraseñas deben ser iguales')

    return errors
  }

  get passwordErrors(): Array<string> {
    const errors: Array<string> = []
    if (!this.$v.password.$dirty) return errors
    !this.$v.password.minLength && errors.push('La contraseña no es válida')
    return errors
  }
}
